import {Component, EventEmitter, Input, Output} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import {getTranslation} from 'shared/helpers/get-translation';

@Component({
  selector: 'download-cert-question',
  templateUrl: 'download-cert-question.html',
  styleUrls: ['download-cert-question.scss'],
})
export class DownloadCertQuestionComponent {

  @Input()
  public title: string;

  @Input()
  public description: string;

  @Output()
  public valueChange: EventEmitter<string> = new EventEmitter<string>();

  public downloadCert(event: Event) {
    event.stopPropagation();
    this.valueChange.emit('DOWNLOAD_CERT');
  }

}
